var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import "./AnalyticsTable.scss";

import Color from "color";
import _ from "lodash";

import TableHead from './AnalyticsTableHead';
import TableBody from './AnalyticsTableBody';

var AnalyticsTable = (_temp2 = _class = function (_Component) {
    _inherits(AnalyticsTable, _Component);

    function AnalyticsTable() {
        var _temp, _this, _ret;

        _classCallCheck(this, AnalyticsTable);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
            report: undefined,
            sortBy: undefined,
            sortOrder: undefined
        }, _this.componentDidUpdate = function (prevProps, prevState) {

            if (prevProps.report !== _this.props.report) {
                _this.getReport();
            }
        }, _this.getReport = function () {
            var _this$props = _this.props,
                report = _this$props.report,
                sortBy = _this$props.sortBy,
                sortOrder = _this$props.sortOrder,
                urlPattern = _this$props.urlPattern;


            _this.setState({
                totals: [],
                maximums: [],
                minimums: [],
                sortedRows: [],
                rows: []
            });

            if (!report) {
                return false;
            }

            var dimensionHeaders = report.columnHeader.dimensions;
            var metricHeaders = report.columnHeader.metricHeader.metricHeaderEntries;

            var _report$data = report.data,
                totals = _report$data.totals,
                maximums = _report$data.maximums,
                minimums = _report$data.minimums,
                rows = _report$data.rows;
            var orderBys = report.request.orderBys;


            var defaultSortBy = void 0,
                defaultSortOrder = void 0;

            if (orderBys && orderBys[0]) {
                defaultSortBy = orderBys[0].fieldName;
                defaultSortOrder = orderBys[0].sortOrder;
            }

            var sortedRows = rows.map(function (row) {

                var metric = {};

                dimensionHeaders.map(function (d, index) {
                    metric[d] = row.dimensions[index];
                });

                metricHeaders.map(function (m, index) {
                    var name = m.name;

                    metric[name] = parseFloat(row.metrics[0].values[index]);
                });

                return _extends({}, row, metric);
            });

            _this.setState({
                urlPattern: urlPattern,
                dimensionHeaders: dimensionHeaders,
                metricHeaders: metricHeaders,
                totals: totals[0].values,
                maximums: maximums[0].values,
                minimums: minimums[0].values,
                sortedRows: sortedRows,
                rows: rows,
                sortBy: sortBy || defaultSortBy || metricHeaders[0].name,
                sortOrder: sortOrder || defaultSortOrder
            });
        }, _this.getClassName = function () {
            return "admin-analytics-table";
        }, _this.onSort = function (sortBy, sortOrder) {

            if (_this.props.onSort) {
                _this.props.onSort(sortBy, sortOrder);
            }

            var sortedRows = _this.state.sortedRows;


            sortedRows = _.orderBy(sortedRows, sortBy, sortOrder); // Use Lodash to sort array by 'name'

            console.log('sortedRows', sortedRows);

            _this.setState({
                sortBy: sortBy,
                sortOrder: sortOrder,
                sortedRows: sortedRows
            });
        }, _this.getThemeStyle = function () {
            var theme = _this.props.theme;


            if (!theme) {
                return {};
            }

            var primaryColor = theme.primaryColor;


            if (!primaryColor) {
                return {};
            }

            var backgroundColor = Color(primaryColor);

            var color = void 0;

            if (backgroundColor.isDark()) {
                color = "white";
            } else {
                color = "black";
            }

            return {
                backgroundColor: backgroundColor,
                color: color
            };
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    AnalyticsTable.prototype.componentDidMount = function componentDidMount() {
        this.getReport();
    };

    AnalyticsTable.prototype.render = function render() {
        var className = this.getClassName();

        var _state = this.state,
            metricHeaders = _state.metricHeaders,
            metricRows = _state.metricRows,
            sortBy = _state.sortBy,
            sortOrder = _state.sortOrder;


        if (!metricHeaders) {
            return false;
        }

        var thWidth = 30;
        var thStyle = {
            width: thWidth + "%"
        };

        var tdWidth = (100 - thWidth) / metricHeaders.length;
        var tdStyle = {
            width: tdWidth + "%"
        };

        var themeStyle = this.getThemeStyle();

        return React.createElement(
            "table",
            { className: className },
            React.createElement(TableHead, _extends({}, this.state, { thStyle: thStyle, tdStyle: tdStyle, themeStyle: themeStyle, onSort: this.onSort })),
            React.createElement(TableBody, _extends({}, this.state, { thStyle: thStyle, tdStyle: tdStyle, onSort: this.onSort }))
        );
    };

    return AnalyticsTable;
}(Component), _class.defaultProps = {
    urlPattern: undefined,
    report: undefined,
    sortBy: undefined,
    sortOrder: 'ascending'
}, _temp2);


export default AnalyticsTable;